var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-collapse-item",
    {
      class: { selected: _vm.isSelected },
      attrs: { name: _vm.name },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "pl-1 py-2 w-100", on: { click: _vm.select } },
                [
                  _c("div", [
                    _c("span", { staticClass: "el-style attribute-name" }, [
                      _vm._v("Sender:"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.sender) + "\n            "),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("span", { staticClass: "el-style attribute-name" }, [
                      _vm._v("Recipient:"),
                    ]),
                    _vm._v(" " + _vm._s(_vm.recipient) + "\n            "),
                  ]),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "pl-1" }, [
        _c("div", { staticClass: "el-style attribute-name" }, [
          _vm._v("Message:"),
        ]),
        _vm._v(" "),
        _c("div", [_vm._v(_vm._s(_vm.message))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }